import React from 'react';
import { styled } from '../../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerGutter,
} from '../../../../components-core/packages/components-core/dist/container';

//STYLE
import { Text, TextAppearance, TextColor } from '../../../../components-core/packages/components-core/dist/text';


class ResultRowService extends React.Component {

    

    render() {
        return (
            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0100}>
                <Text appearance={TextAppearance.copy0200}>
                {this.props.data.webDefinition}
                </Text>
            </Container>
            
        )
    }

}

export default ResultRowService;